module.exports = __webpack_public_path__ + "static/media/monitor.39c75e78.svg";